export default {
	"auth/user-not-found": "forms:emailNotFound",
	"auth/too-many-requests": "forms:tooManyRequests",
	"auth/wrong-password": "forms:wrongPassword",
	"auth/email-already-in-use": "forms:emailInUse",
	"auth/invalid-email": "forms:invalidEmail",
}
